import { Component, Inject, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fromEvent, Observable } from 'rxjs';
import { MyStripeService } from 'src/app/services/apiclient/myStripe/my-stripe.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { DeleteaddressComponent } from '../client-address/deleteaddress/deleteaddress.component';
import {SalemethodService} from "../../../services/api/salemethod/salemethod.service";



@Component({
  selector: 'app-payments-methods-card',
  templateUrl: './payments-methods-card.component.html',
  styleUrls: ['./payments-methods-card.component.css']
})
export class PaymentsMethodsCardComponent implements OnInit {
  eventHeight: Observable<any> = fromEvent(window, "resize");
  innerHeight: number = window.innerHeight;



  currSM: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
  currPOS: any = this.tools.getStor("point_of_sale");

  clientCards: any;
  currCard$: any;
  currPaymentMethod: string;



  loader: boolean = false;


  defaultStripePayMethod: any;
  obserdefault: any;
  obsergetCurrCard: any;
  selectedCard: any
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<PaymentsMethodsCardComponent>,
    private tools: ToolsService,
    private myStripeApi: MyStripeService,
    private dialog: MatDialog,
    private media: MediaObserver,

  ) {

    this.loader = true;

    //en provence de recharge
    this.currSM = data && data.sm ? data.sm : this.currSM;

    this.currPOS = data && data.pos ? data.pos : this.currPOS;



    this.currPaymentMethod = this.currSM.payment_type;

    this.myStripeApi.getPaymentMethod("nodefault").subscribe((cards: any) => {
      this.setClientCards(cards);
      this.loader = false;
    });

  }

  ngOnInit() {


    this.onWindowResize();


    this.obsergetCurrCard = this.myStripeApi.getCurrCard().subscribe(card => {
      this.selectedCard = card;
    });

    this.obserdefault = this.myStripeApi.getDefaultPaymentMethodObser().subscribe(defaultStripePayMethod => {
      this.defaultStripePayMethod = defaultStripePayMethod;
    });
  }

  ngOnDestroy(): void {
    if (this.obserdefault) {
      this.obserdefault.unsubscribe();
    }
    if (this.obsergetCurrCard) {
      this.obsergetCurrCard.unsubscribe();
    }

  }




  /**
   * @description Selectionne une methode de paiement et supprime la currCard
   */
  selectPaymentMethod(pm: any | string): void {

    this.currPaymentMethod = pm;
  }





  /**
   * @description Set les cartes client
   */
  setClientCards(pm: any): void {

    let paymentmethod: any = [];

    if (pm)
      pm.forEach((element: any) => {
        if (element.type === 'card') {
          paymentmethod.push(element);
        }
      });

    this.clientCards = paymentmethod;
    if (!this.clientCards || this.clientCards && this.clientCards.length === 0) {
      this.closeDial();
    }

  }

  onWindowResize() {
    this.eventHeight.subscribe(event => {
      this.innerHeight = event.currentTarget.innerHeight;

    });
  }



  openDialDeletePaymentMethod(paimentmethodstripe: any, index: number) {

    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      from: "pms",
      card: paimentmethodstripe,
      cards: this.clientCards,
      index: index,
      currCard: this.currCard$
    };

    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "500px";
    const myDial = this.dialog.open(DeleteaddressComponent, myConf);
    myDial.afterClosed().subscribe(data => {
      if (data) {
        this.setClientCards(data);
      }
    });
  }

  closeDial(cancel?: any): void {

    //set la carte
    if (!cancel) {
      this.myStripeApi.setCurrCard(this.selectedCard);
    }

    this.currPaymentMethod = "online";

    this.dialogRef.close({
      payment_method: this.currPaymentMethod,
      cards: this.clientCards
    });


  }
  /**
   * @description Selectionne une carte de paiement
   */
  selectStripeCard(selectedCard: any): void {
    this.selectedCard = selectedCard
  }



  setDefaultPaymentStripeMethod(paiement_method: any, $event: any) {

    this.myStripeApi.setDefaultPaymentMethodObser(paiement_method);
    this.myStripeApi.updateCustomerPaymentsMethod(paiement_method.id).subscribe(customer_updated => {

    });
  }
}



